const translations  = {
    "AZ":{
        home:'Ana Səhifə',
        about:"Haqqımızda",
        projects:"Layihələr",
        contact:' Əlaqə',
        workeducation:"İş Təcrübəsi və Təhsil",
        expert:"Mənim Ekspert Sahəm",
        service:"Təklif etdiyim Xidmətlər",
        service1:"Veb Dizayn",
        service2:"SEO OPTİMİZASYASI",
        reserved:"Bütün hüquqlar qorunur.",
        recent:"Son Layihələr",
        allrecent:"Bütün layihələr",
        announcement:"Elan",
        fullstack:"Yaxında Full stack proqramçı",
        talk:"Gəl Danışaq",
        bookcall:"Zəng edin",
        copyemail:"E-mail kopyala",
        ongoing:"Layihəyə texniki dəstək verilir",
        contactMe:'Mənimlə əlaqə <font color="##4770FF"> saxlayın </font>',
        feedback:"Tezliklə geri dönüş olacaq.",
        name:"Ad",
        email:"E-poçt",
        subject:"Mövzu",
        send:"Göndər",
        hi:"Salam,Mən <font color='#4770FF'>Tamerlan</font> 👋",
        freelance:"Freelance mümkündür",
        year:"Təcrübə ili",
        completed:"Layihə Tamamlandı",
        happy:"Xoşbəxt Müştəri",
        who:"Mən kiməm ?",
        aboutme:"Salam, <font color='#4770FF'>mən Tamerlan,</font>  1999-cu ildə Bakı şəhərində anadan olmuşam. 2021-ci ildə Qərbi Kaspi Universitetində Poliqrafiya mühəndisliyi üzrə bakalavr təhsilimi bitirdikdən sonra hərbi xidmət borcumu yerinə yetirdim. Məhz bu dövrdə texnologiyaya olan marağım artdı və nəticədə <font color='#4770FF'>front-end proqramçı </font> sahəsinə apardı.",
        lets:"Birgə Çalışaq 👋",
        download:"CV Yükləyin",
        checkout:"Ən Son <br/> <font color='#4770FF'> Layihələrimə baxın </font>",
        aboutsite:"<font color='#4770FF'>veb-sayt</font> haqqında",
        projectname:"Layihə adı",
        overview:"Ümumi baxış"
    },
    "EN":{
        home:"Home",
        about:"About",
        projects:"Projects",
        contact:'Contact',
        workeducation:"Work Experience & Education",
        expert:"My Expert Area",
        service:"Services I Offered",
        service1:"Website Design",
        service2:"SEO OPTIMIZATION",
        reserved:"All rights reserved.",
        recent:"Recent Projects",
        allrecent:"All Projects",
        announcement:"Announcement",
        fullstack:"Full stack developer coming soon",
        talk:"Let's Talk",
        bookcall:"Book A call",
        copyemail:"Copy Email",
        ongoing:"Technical support is provided to the project",
        contactMe:'Contact <font color="#4770FF"> Me </font>',
        feedback:"There will be a comeback soon.",
        name:"Name",
        email:"Email",
        subject:"SUbject",
        send:"Send Messages",
        hi:"Hi,I' <font color='#4770FF'>Tamerlan</font> 👋",
        freelance:"Freelance is possible",
        year:"Year of Experience",
        completed:"Project Completed",
        happy:"Happy Client",
        who:"Who am I ?",
        aboutme:"Greetings, <font color='#4770FF'>I am Tamerlan,</font> born in Baku in 1999. Following the completion of my Bachelor's degree in Polygraphy Engineering from Western Caspian University in 2021, I fulfilled my military service obligations. It was during this period that my intrigue for t technology burgeoned, ultimately leading me to venture into the realm of <font color='#4770FF'>front-end development.</font>",
        lets:"Let's 👋 Work Together",
        download:"Download CV",
        checkout:"Check Out <br/> <font color='#4770FF'> My Latest Projects </font>",
        aboutsite:"about the <font color='#4770FF'> site </font>",
        projectname:"Project name",
        overview:"Overview"
    }
}


export default translations ;